<template>
  <div class="i-breadcrumb breadcrumbs-container" :class="size">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="item"
      :class="{ active: item.active }"
      @mouseover="mouseEnter(index)"
      @mouseleave="mouseEnter(null)"
      @click="goTo(item)"
    >
      <i-icon
        v-if="item.icon"
        :symbol="item.icon"
        class="icon"
        :class="{
          'i-text-neutral-120': index === hoverIndex,
          'i-text-neutral-90': index !== hoverIndex,
        }"
        :size="iconSize"
      ></i-icon>
      <span v-if="item.text" class="text">{{ item.text }}</span>
      <span v-if="index < items.length - 1" class="chevron">
        <i-icon
          symbol="medium-chevron-right"
          class="i-text-neutral-90"
          :size="iconSize"
        ></i-icon>
      </span>
    </div>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';

export default {
  components: {
    'i-icon': iIcon,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  data() {
    return {
      hoverIndex: null,
      iconSize: this.size === 'lg' ? 24 : 16,
    };
  },
  methods: {
    goTo(item) {
      this.$router.push(item.to);
    },
    mouseEnter(index) {
      this.hoverIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs-container {
  display: flex;
  flex-direction: row;

  &.lg {
    .item {
      font-weight: 600;
      font-size: 20px;
      line-height: 24px;
    }
  }

  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: $light-neutral-90;
    cursor: pointer;

    &:hover,
    &.active {
      color: $light-neutral-120;
    }

    .text {
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .chevron {
      padding: 0 4px;
    }
  }
}
</style>
